import { APIMethod as ApiMethods, fetchData } from "@client";

export async function createXlsImportConfigQuery(
  name,
  config,
) {
  const res = await fetchData(
    "/xls-configs",
    ApiMethods.POST,
    {
      data: {
        name,
        config,
      }
    }
  );
  
  return res?.results;
}
